var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5624_20946)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.9429,
    height: 27.0961,
    transform: "translate(0 0.45166)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.9716,
    cy: 13.9997,
    r: 13.0481,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9717 7.97803V20.0208",
    stroke: "#150F2F",
    strokeWidth: 1.69351,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95007 14H19.9928",
    stroke: "#150F2F",
    strokeWidth: 1.69351,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5624_20946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.9429,
    height: 27.0961,
    fill: "white",
    transform: "translate(0 0.45166)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOutline);
export default __webpack_public_path__ + "static/media/add-outline.91c41e70.svg";
export { ForwardRef as ReactComponent };